import { ProductModel } from "./product.model";
import { PromotionModel } from "./promotion.model";

export class MarkerModel {

    public uuid: string;
    public markerType: string;
    public yaw: number;
    public pitch: number;
    public distance: number;
    public product: ProductModel;
    public enabled: boolean;
    linkedPhotosphereUUID: string;
    public promotionUuid: string;
    public promotion?: PromotionModel;
    public productMeasure: string;

    constructor(value?: JSON) {
        if(value) {
            this.uuid = value["uuid"];
            this.markerType = value["marker_type"];
            this.yaw = value["position_yaw"];
            this.pitch = value["position_pitch"];
            this.distance = value["distance"];
            this.enabled = value["enabled"];
            if(value["product"]) {
                this.product = new ProductModel(value["product"]);
            }
            if (value["linked_photosphere"]) {
                this.linkedPhotosphereUUID = value["linked_photosphere"]["uuid"];
            }
            if (value["promotion_uuid"]) {
                this.promotionUuid = value["promotion_uuid"];
            }
            this.productMeasure = value["product_info"];
        }
    }
}